import { NavLink } from 'react-router-dom'
import { Sheet, SheetContent, SheetHeader, SheetTitle, Badge } from '@/components/ui'
import { cn } from '@/lib/utils'
import { secondaryNavigation, useFilteredNavigation } from './navigation'

interface MobileNavProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  unreadAlerts?: number
}

export function MobileNav({ open, onOpenChange, unreadAlerts = 0 }: MobileNavProps) {
  const filteredNavigation = useFilteredNavigation()

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="left" className="w-72 p-0">
        <SheetHeader className="border-b border-gray-200 px-6 py-4">
          <SheetTitle className="text-xl font-serif font-bold text-primary-600">FamSteady</SheetTitle>
        </SheetHeader>

        <nav className="flex flex-1 flex-col px-3 py-4">
          <ul className="flex flex-1 flex-col gap-1">
            {filteredNavigation.map((item) => (
              <li key={item.name}>
                <NavLink
                  to={item.href}
                  onClick={() => onOpenChange(false)}
                  className={({ isActive }) =>
                    cn(
                      'group flex items-center gap-3 rounded-md px-3 py-2.5 text-sm font-medium transition-colors',
                      isActive
                        ? 'bg-primary-50 text-primary-700'
                        : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'
                    )
                  }
                >
                  {({ isActive }) => (
                    <>
                      <item.icon
                        className={cn(
                          'h-5 w-5 shrink-0',
                          isActive ? 'text-primary-600' : 'text-gray-400 group-hover:text-gray-500'
                        )}
                      />
                      <span className="flex-1">{item.name}</span>
                      {item.badge && unreadAlerts > 0 && (
                        <Badge variant="error" className="ml-auto">
                          {unreadAlerts > 99 ? '99+' : unreadAlerts}
                        </Badge>
                      )}
                    </>
                  )}
                </NavLink>
              </li>
            ))}
          </ul>

          {/* Secondary navigation */}
          <ul className="mt-auto border-t border-gray-200 pt-4">
            {secondaryNavigation.map((item) => (
              <li key={item.name}>
                <NavLink
                  to={item.href}
                  onClick={() => onOpenChange(false)}
                  className={({ isActive }) =>
                    cn(
                      'group flex items-center gap-3 rounded-md px-3 py-2.5 text-sm font-medium transition-colors',
                      isActive
                        ? 'bg-primary-50 text-primary-700'
                        : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'
                    )
                  }
                >
                  {({ isActive }) => (
                    <>
                      <item.icon
                        className={cn(
                          'h-5 w-5 shrink-0',
                          isActive ? 'text-primary-600' : 'text-gray-400 group-hover:text-gray-500'
                        )}
                      />
                      {item.name}
                    </>
                  )}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </SheetContent>
    </Sheet>
  )
}
